<div class="-sf-container">
  <div *ngIf="solutionFinderResponse" class="-sf-card-row">
    <div class="-sf-content-container">
      <h3>{{ solutionFinderResponse.title }}</h3>
      <p>{{ solutionFinderResponse.desc }}</p>
    </div>
    <app-link [to]="solutionFinderResponse.path">{{ solutionFinderResponse.solutiontitle }}</app-link>
  </div>
</div>
